<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.parent.name | translate }} - {{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("common.create") }}</span>
      </h2>

      <sweet-input
        class=""
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('common.name')"
      />

      <label class="mt-3" for="parent-filter">{{ $t("file-manager.file-category.select-parent") }}</label>
      <filter-select
        id="parent-filter"
        ref="parent-filter"
        :placeholder="$t('file-manager.file-category.select-parent')"
        :multiple="false"
        @filter="onParentSearch"
        :selected="form.parent"
        @changed="parentSelect"
        track="_id"
      />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
const state = "organizationFileCategory";

export default {
  props: ["scope", "closeOnSave"],
  data() {
    return {
      form: { parent: undefined, name: undefined },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      parent: { required },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },

    selectedParentCategory() {
      return this.$store.getters["organizationFileCategory/selectedParentCategory"];
    },
    selectedSubCategory() {
      return this.$store.getters["organizationFileCategory/selectedCategory"];
    },
  },
  async mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));

        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-file-category");
        }
        setTimeout(() => this.$emit("onFormSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onParentSearch(value, callback) {
      const response = await this.$store.dispatch(`${state}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, products: { value: this.scope || "PLATFORM", isObject: true }, parent: { value: { $exists: false }, isObject: true } },
      });
      callback(response.data?.docs ?? []);
    },
    parentSelect(item) {
      this.form = { ...this.form, parent: item };
    },
  },
};
</script>
